export default {
  fontFamily: [
    'MarsCentra',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
    'system-ui',
  ].join(','),
  h1: {
    fontWeight: 500,
    fontSize: 35,
    letterSpacing: '-0.24px'
  },
  h2: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: '-0.24px'
  },
  h3: {
    fontWeight: 500,
    fontSize: '1.2rem',
    '@media (min-width:600px)': {
      fontSize: '1.5rem',
    },
    letterSpacing: '-0.06px'
  },
  h4: {
    fontWeight: 500,
    fontSize: '1.1rem',
    '@media (min-width:600px)': {
      fontSize: '1.3rem',
    },
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  },
  text1: {
    fontWeight: 500,
    fontSize: '12px',

  },
  text2: {
    fontWeight: 400,
    fontSize: '10px'
  },
  text3: {
    fontWeight: 700,
    fontSize: '16px'
  },
  text4: {
    fontWeight: 400,
    fontSize: '18px'
  },
  text5: {
    fontWeight: 700,
    fontSize: '14px'
  },
  text6: {
    fontWeight: 400,
    fontSize: '12px'
  },
  text7: {
    fontWeight: 700,
    fontSize: '10px'
  }
};
